import React, { useState, useEffect, useRef } from 'react'
import { all_routes } from '../../router/all_routes'
import { Link } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { DatePicker } from 'antd';
import Select from "react-select";
import "../../../style/css/meetingForm.css";
import { formSubmittion } from "../../Services/ApiCalling";
import { Button, Form, Row, Col, Card } from 'react-bootstrap';
import * as Yup from "yup";
import dayjs from "dayjs";

const nameRegex = /^[A-Za-z\s]+$/;

const meetingFormValidationSchema = Yup.object().shape({

    client_name: Yup.string()
        .matches(nameRegex, "Only letters and spaces are allowed")
        .required("Client name is required"),

    person_name: Yup.string()
        .matches(nameRegex, "Only letters and spaces are allowed")
        .required("Person name is required"),

    designation: Yup.string()
        .matches(nameRegex, "Only letters and spaces are allowed")
        .required("Designation is required"),

    department: Yup.string()
        .matches(nameRegex, "Only letters and spaces are allowed")
        .required("Department is required"),

    email: Yup.string()
        .email("Invalid email")
        .required("Email is required"),

    // phone_type: Yup.string().required("Phone type is required"),

    phone: Yup.string()
        .required("Phone number is required")
        .matches(/^\d+$/, "Only numbers are allowed")
        .length(10, "Mobile number should be 10 digits")
        .test(
            "starts-with",
            "Mobile number must start with 6-9",
            (value) => value && /^[6-9]/.test(value)
        ),

});

const MeetingForm = ({ bd_names, load }) => {

    const token = localStorage.getItem("LoginToken");
    const [errorsArray, setErrorsArray] = useState([]);
    const [loadSubmit, setLoadSubmit] = useState(false);

    const today = dayjs(); // current date
    const yesterday = today.subtract(1, "day"); // yesterday

    const [formData, setFormData] = useState({
        bd_person_name: "",
        date: null,
        mode_of_meeting: "",
        type_of_meeting: "",
        client_name: "",
        person_name: "",
        designation: "",
        department: "",
        email: "",
        phone_type: null,
        phone: "",
        summary: "",
        next_step: "",
        remark: ""
    });


// console.log("typeMeeting",formData?.type_of_meeting);

    const modeOptions = [
        { value: "Virtual", label: "Virtual" },
        { value: "In Person", label: "In Person" },
        { value: "Telephonic", label: "Telephonic" },
    ];

    const meetingOptions = [
        { value: "Liaison", label: "Liaison" },
        { value: "Enquiry", label: "Enquiry" },
        { value: "Tender", label: "Tender" },
        { value: "Ongoing Project", label: "Ongoing Project" },
        { value: "Conference", label: "Conference" },
        { value: "Client Visit", label: "Client Visit" },
        { value: "Partnership", label: "Partnership" }
    ];

    const phoneTypeOptions = [
        { value: "Official", label: "Official" },
        { value: "Personal", label: "Personal" },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoadSubmit(true)
            await meetingFormValidationSchema.validate(formData, { abortEarly: false });
            setErrorsArray([]);
            const respp = await formSubmittion(formData, token)
            if (respp?.data) {
                toast.success(respp?.message, { position: "top-center" });
            } else {
                toast.success(respp?.message || "Something went wrong", { position: "top-center" });
            }

            setFormData({
                bd_person_name: "",
                date: null,
                mode_of_meeting: "",
                type_of_meeting: "",
                client_name: "",
                person_name: "",
                designation: "",
                department: "",
                email: "",
                phone_type: null,
                phone: "",
                summary: "",
                next_step: "",
                remark: ""
            })
        } catch (err) {
            if (err.inner) {
                const validationErrors = err.inner.map(error => ({
                    field: error.path,
                    message: error.message
                }));

                setErrorsArray(validationErrors);

            } else {
                console.error(err);
                toast.error("Validation failed", { position: "top-center" });
            }
        } finally {
            setLoadSubmit(false); 
        }

    };

    console.log("yashyash", errorsArray)

    // Custom style for react-select to match form-control
    const selectStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "38px",
            height: "38px",
            fontSize: "14px",
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "38px",
            padding: "0 6px",
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "38px",
        }),
    };

    const getError = (fieldName) => errorsArray.find(e => e.field === fieldName)?.message;

    return (
        <div className="page-wrapper" style={{ backgroundColor: "#faf9f8", minHeight: "100vh" }}>
            <div className="content container-fluid">
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <h2 className="mb-1">Meeting Form</h2>
                </div>

                <Card className="shadow-sm rounded-4 p-4">
                    <form onSubmit={handleSubmit}>
                        {/* Meeting Info */}
                        <Row className="mb-3">
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>BD Person</label><span style={{ color: "red" }} >*</span>
                                <Select
                                    classNamePrefix="react-select"
                                    options={bd_names}
                                    placeholder="Select Name"
                                    value={formData.bd_person_name}
                                    required
                                    isLoading={load}
                                    onChange={(value) =>
                                        setFormData({ ...formData, bd_person_name: value })
                                    }
                                    styles={selectStyles}
                                />
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Date</label><span style={{ color: "red" }} >*</span>
                                <DatePicker
                                    value={formData?.date}
                                    // selected={formData?.date}
                                    onChange={(date) => setFormData({ ...formData, date })}
                                    className="form-control"
                                    dateFormat="yyyy-MM-dd"
                                    placeholderText="Select Date"
                                    required
                                    minDate={yesterday}
                                    maxDate={today}
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Mode of Meeting</label><span style={{ color: "red" }} >*</span>
                                <Select
                                    classNamePrefix="react-select"
                                    options={modeOptions}
                                    placeholder="Select Mode"
                                    name="mode_of_meeting"
                                    value={formData.mode_of_meeting}
                                    required
                                    onChange={(value) =>
                                        setFormData({ ...formData, mode_of_meeting: value })
                                    }
                                    styles={selectStyles}
                                />
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Type of Meeting</label><span style={{ color: "red" }} >*</span>
                                <Select
                                    classNamePrefix="react-select"
                                    options={meetingOptions}
                                    placeholder="Select Meeting Type"
                                    name="type_of_meeting"
                                    value={formData.type_of_meeting}
                                    required
                                    onChange={(value) =>
                                        setFormData({ ...formData, type_of_meeting: value })
                                    }
                                    styles={selectStyles}
                                />
                            </Col>

                        </Row>


                        {/* Contact Info */}
                        <Row className="mb-3">
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Client Name</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="client_name"
                                    className="form-control hover-input"
                                    placeholder="Enter Client Name"
                                    value={formData.client_name}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("client_name") && (
                                    <p style={{ color: "red" }} >{getError("client_name")}</p>
                                )}
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Person Name</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="person_name"
                                    className="form-control hover-input"
                                    placeholder="Enter Person Name"
                                    value={formData.person_name}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("person_name") && (
                                    <p style={{ color: "red" }} >{getError("person_name")}</p>
                                )}
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Designation</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="designation"
                                    className="form-control hover-input"
                                    placeholder="Enter Designation"
                                    value={formData.designation}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("designation") && (
                                    <p style={{ color: "red" }} >{getError("designation")}</p>
                                )}
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Department</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="department"
                                    className="form-control hover-input"
                                    placeholder="Enter Department"
                                    value={formData.department}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("department") && (
                                    <p style={{ color: "red" }} >{getError("department")}</p>
                                )}
                            </Col>

                        </Row>

                        {/* Phone */}
                        <Row className="mb-3">
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Email</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control hover-input"
                                    placeholder="Enter Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("email") && (
                                    <p style={{ color: "red" }} >{getError("email")}</p>
                                )}
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Phone Type</label><span style={{ color: "red" }} >*</span>
                                <Select
                                    classNamePrefix="react-select"
                                    options={phoneTypeOptions}
                                    placeholder="Select Phone Type"
                                    value={formData.phone_type}
                                    required
                                    onChange={(value) =>
                                        setFormData({ ...formData, phone_type: value })
                                    }
                                    styles={selectStyles}
                                />
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Phone</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control hover-input"
                                    placeholder="Enter Phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                                {getError("phone") && (
                                    <p style={{ color: "red" }} >{getError("phone")}</p>
                                )}
                            </Col>
                            <Col md={3}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Summary</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="summary"
                                    className="form-control hover-input"
                                    placeholder="Summary"
                                    value={formData.summary}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </Row>

                        {/* Next Step & Remark */}
                        <Row className="mb-3">
                            <Col md={6}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Next Step</label><span style={{ color: "red" }} >*</span>
                                <input
                                    type="text"
                                    name="next_step"
                                    className="form-control hover-input"
                                    placeholder="Next Step"
                                    value={formData.next_step}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <label className="form-label" style={{ fontSize: "16px" }}>Remark</label><span>(Optional)</span>
                                <input
                                    type="text"
                                    name="remark"
                                    className="form-control hover-input"
                                    placeholder="Remark"
                                    value={formData.remark}
                                    onChange={handleChange}

                                />
                            </Col>
                        </Row>

                        <button
                            type="submit"
                            className="btn meeting-submit-btn"
                            disabled={loadSubmit === true}
                        >
                            {loadSubmit ? (
                                <>
                                    Save Meeting
                                    <i className="fas fa-spinner fa-spin ms-2" />
                                </>
                            ) : (
                                "Save Meeting"
                            )}

                        </button>
                    </form>
                </Card>
            </div>
        </div>
    );
}

export default MeetingForm

